require('./choreListTableInfoRow.scss');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKIconButton } = require('commonsComponents/OKIconButton');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ actions
const openYoungCardChores = require('actions/openYoungCardChores');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { hash } = require('utilities/hash');

// @ constant
const {
    OPENYOUNG_CHORE_WIP,
    OPENYOUNG_CHORE_PENDING,
    OPENYOUNG_CHORE_APPROVED,
    OPENYOUNG_CHORE_REJECTED,
    OPENYOUNG_CHORE_CANCEL,
} = require('constants/index');

class ChoreListTableInfoRow extends React.Component {

    constructor(props) {
        super(props);
        this.buildDetailsSection = this.buildDetailsSection.bind(this);
        this.buildDetailRowItem = this.buildDetailRowItem.bind(this);
        this.buildLoadingSection = this.buildLoadingSection.bind(this);
        this.buildButtonSection = this.buildButtonSection.bind(this);
        this.handleDeleteChore = this.handleDeleteChore.bind(this);
        this.buildErrorSection = this.buildErrorSection.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleEditChore = this.handleEditChore.bind(this);
        this.generateHashedPan = this.generateHashedPan.bind(this);
    }

    componentDidMount() {
        const { getChoreDetail, immTransaction } = this.props;
        if(!immTransaction.get('isExpanded')){
            getChoreDetail(immTransaction.get('choreAssignmentId'));
        }
    }

    generateHashedPan(pan) {
        const { immCards } = this.props;
        let hashedPan = '';
        immCards.get('byId').every((immCard) => {
            const fullPanNumber = immCard.getIn(['interventionList', 0, 'pan']);
            const last4DigitPanCard = fullPanNumber.substr(fullPanNumber.length - 4);
            const isPanNumberMatched = pan === last4DigitPanCard;
            if (isPanNumberMatched) {
                hashedPan = hash(fullPanNumber);
            }
            return !isPanNumberMatched;
        });
        return hashedPan;
    }

    handleEditChore(){
        const { history, immTransaction } = this.props;
        const cardId = this.generateHashedPan(immTransaction.get('last4DigitPan'));
        const choreAssignmentId = this.props.immTransaction.get('choreAssignmentId');
        history.push(`/myprofile/cards/${cardId}/chores/modify-chore/${choreAssignmentId}`);
    }

    handleDeleteChore() {
        const { history, immTransaction } = this.props;
        const cardId = this.generateHashedPan(immTransaction.get('last4DigitPan'));
        const choreAssignmentId = this.props.immTransaction.get('choreAssignmentId');
        history.push(`/myprofile/cards/${cardId}/chores/delete-chore/${choreAssignmentId}`);
    }

    buildButtonSection() {
        const { openYoungCardChores, immTransaction } = this.props;
        if (!openYoungCardChores.get('getChoreDetailError') && !openYoungCardChores.get('getChoreDetailFetch')) {
            const choreStatusId = openYoungCardChores.getIn(['choreDetail','choreStatus','choreStatusId']);
            const editButtonHideCategory = [OPENYOUNG_CHORE_CANCEL, OPENYOUNG_CHORE_PENDING, OPENYOUNG_CHORE_APPROVED, OPENYOUNG_CHORE_REJECTED];
            const cancelButtonShowCategory = [OPENYOUNG_CHORE_WIP];
            const deleteButtonHideCategory = [OPENYOUNG_CHORE_PENDING];
            const choreAssignmentId = immTransaction.get('choreAssignmentId');
            const cardId = this.generateHashedPan(immTransaction.get('last4DigitPan'));
            const cancelLink = `/myprofile/cards/${cardId}/chores/cancel-chore/${choreAssignmentId}`;
            let editButton;
            let cancelButton;
            let deleteButton;
            if(!editButtonHideCategory.includes(choreStatusId)) {
                editButton = (
                    <span className="chore-list-table-info-row__edit-button">
                        <OKIconButton icon="icon-editar" onClick={this.handleEditChore} />
                    </span>
                );
            }
            if(cancelButtonShowCategory.includes(choreStatusId)) {
                cancelButton = (
                    <span className="chore-list-table-info-row__cancel-button">
                        <OKButton
                            modifier="secondary"
                            size="small"
                            to={cancelLink}
                        >
                            <FormattedText value="openYoungChoresListDetail-cancelButton" format="firstUppercase"/>
                        </OKButton>
                    </span>
                );
            }
            if(!deleteButtonHideCategory.includes(choreStatusId)) {
                deleteButton = (
                    <span className="chore-list-table-info-row__delete-button">
                        <OKIconButton icon="icon-eliminar" onClick={this.handleDeleteChore}/>
                    </span>
                );
            }
            return (
                <section className="chore-list-table-info-row__button-section">
                    {editButton}
                    {deleteButton}
                    {cancelButton}
                </section>
            );
        }
    }

    buildLoadingSection() {
        if (this.props.openYoungCardChores.get('getChoreDetailFetch')) {
            return <LoadingSection />;
        }
    }

    handleRetry() {
        const { getChoreDetail, immTransaction } = this.props;
        getChoreDetail(immTransaction.get('choreAssignmentId'));
    }

    buildErrorSection() {
        const { openYoungCardChores } = this.props;
        const retryButton = (
            <OKButton onClick={this.handleRetry}>
                <FormattedText value="openYoungChores-retry" />
            </OKButton>
        );
        if (openYoungCardChores.get('getChoreDetailError')) {
            return (
                <EmptyState
                    primaryText={formatText('openYoungChoresListDetail-emptyDetail')}
                    button={retryButton}
                    iconType="nointernet-banking" />
            );
        }
    }
    buildDetailsSection() {
        const { openYoungCardChores } = this.props;
        let detailsSection;

        if (!openYoungCardChores.get('getChoreDetailError') && !openYoungCardChores.get('getChoreDetailFetch')) {
            const detailInfo = this.buildDetailRowItem();
            detailsSection = (
                <OKTableRowDetails title="openYoungChoresListDetail-title" columns={2}>
                    {detailInfo}
                </OKTableRowDetails>
            );
        }

        return detailsSection;

    }

    buildDetailRowItem() {
        const { openYoungCardChores } = this.props;
        const choreDetail = openYoungCardChores.get('choreDetail');

        const items = [
            {
                label: formatText('openYoungChoresListDetail-typeOfOperation'),
                value: formatText(`openYoungCardChores-task${choreDetail.getIn(['chore','choreId'])}`)
            },
            {
                label: formatText('openYoungChoresListDetail-repetitions'),
                value: choreDetail.get('repeatTask') || formatText('openYoungRejectChores-noRepitition')
            },
            {
                label: formatText('openYoungChoresListDetail-choreAssignmentComment'),
                value: choreDetail.getIn(['comments','choreAssignmentComment'])
            },
            {
                label: formatText('openYoungChoresListDetail-childComment'),
                value: choreDetail.getIn(['comments','childComment'])
            },
            {
                label: formatText('openYoungChoresListDetail-choreConfirmationComment'),
                value: choreDetail.getIn(['comments','choreConfirmationComment'])
            }
        ];

        return items.filter(({ value }) => value).map(({label, value}, index) => (
            <OKTableRowDetailsItem
                key={`firstColumnTransferInfo-${index}`}
                title={label}
                value={value}
            />
        ))
    }

    render() {
        return(
            <OKTableRow>
                <OKTableCell />
                <OKTableCell />
                <OKTableCell colSpan={3}>
                    {this.buildLoadingSection()}
                    {this.buildErrorSection()}
                    {this.buildDetailsSection()}
                    {this.buildButtonSection()}
                </OKTableCell>
                <OKTableCell />
            </OKTableRow>
        );
    }
}

ChoreListTableInfoRow.propTypes = {
    getChoreDetail: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    openYoungCardChores: PropTypes.object.isRequired,
    match: PropTypes.object,
};

module.exports.constructor = ChoreListTableInfoRow;
module.exports.ChoreListTableInfoRow = connect(
    state => ({
        immCards: state.cards,
        openYoungCardChores: state.openYoungCardChores,
    }),
    {
        getChoreDetail: openYoungCardChores.getChoreDetail
    }
)(withRouter(ChoreListTableInfoRow));
